const toolsActionsPrefix = "tools";

export const toolsActions = {
  EXPORT_PDF: `${toolsActionsPrefix}/export-pdf`,
  EXPORT_EXCEL: `${toolsActionsPrefix}/export-excel`,
  COLUMNS_MODAL_OPEN: `${toolsActionsPrefix}/columns-modal-open`,
  COLUMNS_MODAL_CLOSE: `${toolsActionsPrefix}/columns-modal-close`,
};
